export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10954.ba498b7f.jpg";